const ALERT = {
  SHOW: 'ALERT.SHOW',
}

export default ALERT
